const steps = [
  {
    number: '01',
    icon: 'ri-alert-line',
    title: 'Проблемы',
    description: 'Выявление бизнес-задач и проблем, которые необходимо решить через обучение. Анализ текущих показателей: продажи, текучесть, вовлеченность.',
  },
  {
    number: '02',
    icon: 'ri-search-eye-line',
    title: 'Диагностика',
    description: 'Оценка текущего уровня компетенций сотрудников. Интервью с руководителями, наблюдение за работой, тестирование и опросы.',
  },
  {
    number: '03',
    icon: 'ri-file-list-3-line',
    title: 'Программа обучения',
    description: 'Разработка индивидуальной программы. Определение целей, форматов, длительности и критериев оценки результата.',
  },
  {
    number: '04',
    icon: 'ri-flashlight-line',
    title: 'Практика',
    description: '80% времени — отработка навыков. Ролевые игры, кейсы компании, бизнес-симуляции, упражнения и обратная связь.',
  },
  {
    number: '05',
    icon: 'ri-rocket-line',
    title: 'Внедрение',
    description: 'Применение полученных навыков в реальной работе. Домашние задания и планы действий между модулями обучения.',
  },
  {
    number: '06',
    icon: 'ri-user-voice-line',
    title: 'Сопровождение',
    description: 'Пост-тренинговая поддержка: консультации, разбор сложных ситуаций, дополнительные материалы и трекинг прогресса.',
  },
  {
    number: '07',
    icon: 'ri-bar-chart-2-line',
    title: 'Оценка результатов',
    description: 'Измерение эффективности по модели Киркпатрика. Сравнение показателей до и после, отчет и рекомендации.',
  },
];

export default function HowSystemBuilt() {
  return (
    <section id="how-system" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-gray-900 mb-6 leading-tight">
            Как компании строят систему корпоративного обучения
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Эффективное обучение — это не разовые тренинги, а системный процесс. Вот 7 этапов построения работающей системы обучения персонала.
          </p>
        </div>

        <div className="relative">
          {/* Vertical line for desktop */}
          <div className="hidden lg:block absolute left-1/2 top-0 bottom-0 w-0.5 bg-teal-200 -translate-x-1/2"></div>

          <div className="space-y-10 lg:space-y-0">
            {steps.map((step, index) => (
              <div
                key={step.number}
                className={`relative flex flex-col lg:flex-row items-start gap-6 lg:gap-0 lg:mb-16 ${index === steps.length - 1 ? 'lg:mb-0' : ''}`}
              >
                {/* Left side (even rows) or spacer (odd rows) */}
                <div className={`hidden lg:flex flex-1 ${index % 2 === 0 ? 'justify-end pr-12' : ''}`}>
                  {index % 2 === 0 && (
                    <div className="bg-gray-50 rounded-2xl p-6 border border-gray-100 max-w-lg hover:shadow-lg transition-shadow">
                      <div className="flex items-center gap-4 mb-3">
                        <span className="text-4xl font-extrabold text-teal-200">{step.number}</span>
                        <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center">
                          <i className={`${step.icon} text-xl text-teal-600`}></i>
                        </div>
                        <h3 className="text-xl font-bold text-gray-900">{step.title}</h3>
                      </div>
                      <p className="text-gray-600 text-sm leading-relaxed">{step.description}</p>
                    </div>
                  )}
                </div>

                {/* Center dot */}
                <div className="hidden lg:flex absolute left-1/2 -translate-x-1/2 w-4 h-4 bg-teal-600 rounded-full border-4 border-teal-100 z-10"></div>

                {/* Right side (odd rows) or spacer (even rows) */}
                <div className={`hidden lg:flex flex-1 ${index % 2 === 1 ? 'justify-start pl-12' : ''}`}>
                  {index % 2 === 1 && (
                    <div className="bg-gray-50 rounded-2xl p-6 border border-gray-100 max-w-lg hover:shadow-lg transition-shadow">
                      <div className="flex items-center gap-4 mb-3">
                        <span className="text-4xl font-extrabold text-teal-200">{step.number}</span>
                        <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center">
                          <i className={`${step.icon} text-xl text-teal-600`}></i>
                        </div>
                        <h3 className="text-xl font-bold text-gray-900">{step.title}</h3>
                      </div>
                      <p className="text-gray-600 text-sm leading-relaxed">{step.description}</p>
                    </div>
                  )}
                </div>

                {/* Mobile layout */}
                <div className="lg:hidden flex items-start gap-4 bg-gray-50 rounded-2xl p-6 border border-gray-100 w-full">
                  <div className="flex-shrink-0">
                    <span className="block text-3xl font-extrabold text-teal-200 mb-2">{step.number}</span>
                    <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center">
                      <i className={`${step.icon} text-xl text-teal-600`}></i>
                    </div>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">{step.title}</h3>
                    <p className="text-gray-600 text-sm leading-relaxed">{step.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}